let language = {

    "resourceLibrary:Sort:Created:Newest": "创建时间：最新",
    "resourceLibrary:Sort:Created:Oldest": "创建时间：最早",
    "resourceLibrary:Sort:Name:Asc": "名称: A 到 Z",
    "resourceLibrary:Sort:Name:Desc": "名称: Z 到 A",
    
  
};

export { language }